import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Userstoriestable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      tables: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.userstoriestable_Id,
          sortable: true,
          cell: (row) => <span>{row.userstoriestable_Id}</span>,
        },
        {
          name: "ProjectName",
          selector: (row, i) => row.projectName,
          sortable: true,
          cell: (row) => <span>{row.projectName}</span>,
        },
        {
          name: "UserStory ",
          selector: (row, i) => row.userStory,
          sortable: true,
          cell: (row) => <span>{row.userStory}</span>,
        },
        {
          name: "Tasks table",
          selector: (row, i) => row.taskstable,
          sortable: true,
          cell: (row) => <span>{row.taskstable}</span>,
        },
        {
          name: "Qualification Criteria 1",
          selector: (row, i) => row.dummyOne,
          sortable: true,
          cell: (row) => <span>{row.dummyOne}</span>,
        },
        {
          name: "Qualification Criteria 2",
          selector: (row, i) => row.dummyTwo,
          sortable: true,
          cell: (row) => <span>{row.dummyTwo}</span>,
        },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.UserstoriestableeditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      userstoriestable_Id: "",
      itprojectstable: [],
      projectName: "",
      userStory: "",
      taskstable: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      projectName: "",
      userStory: "",
      taskstable: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      projectName: "",
      userStory: "",
      taskstable: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  UserstoriestableeditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true,
      userstoriestable_Id: row.userstoriestable_Id,

      projectName: row.projectName,
      userStory: row.userStory,
      taskstable: row.taskstable,
      dummyOne: row.dummyOne,
      dummyTwo: row.dummyTwo,
      dummyThree: row.dummyThree,
      dummyFour: row.dummyFour,
      dummyFive: row.dummyFive, //***editstate
    });
  };

  UserstoriestablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Userstoriestable/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  UserstoriestablesubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("projectName", this.state.projectName);
    formData.append("userStory", this.state.userStory);
    formData.append("taskstable", this.state.taskstable);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Userstoriestable/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.UserstoriestablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            itprojectstable: [],
            projectName: "",
            userStory: "",
            taskstable: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",

            dummyFour: "",
            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  UserstoriestableupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("userstoriestable_Id", this.state.userstoriestable_Id);
    formData.append("projectName", this.state.projectName);
    formData.append("userStory", this.state.userStory);
    formData.append("taskstable", this.state.taskstable);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Userstoriestable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.UserstoriestablefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.UserstoriestablefetchHandler();
    this.itprojectstablefetchHandler();
    this.getTables();
    //***componentDidMount
  }
  handleprojectNameChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ projectName: fieldValue });
  };
  getTables = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "masters/gettables", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ tables: data.tables });
        }
      });
  };
  itprojectstablefetchHandler = () => {
    fetch(configData.api_url + "C_Itprojectstable/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ itprojectstable: data.list });
        }
      });
  };
  handleuserStoryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ userStory: fieldValue });
  };
  handletaskstableChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskstable: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  };
  handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };

  handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  };
  handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("userstoriestable_Id", row.userstoriestable_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Userstoriestable/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.UserstoriestablefetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        User Stories
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add User Stories</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="tableName"
                                        onChange={this.handleprojectNameChange}
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Project Name{" "}
                                        </option>
                                        {this.state.itprojectstable.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.projectName}
                                            >
                                              {" "}
                                              {api.projectName}{" "}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.projectName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Story{" "}
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={4}
                                        onChange={this.handleuserStoryChange}
                                        className="form-control"
                                        name="userStory"
                                        value={this.state.userStory}
                                        required="required"
                                        placeholder="Enter User Story "
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.userStory}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Tasks Table
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={this.handletaskstableChange}
                                        className="form-control"
                                        name="taskstable"
                                        value={this.state.taskstable}
                                        required="required"
                                        placeholder="Enter Tasks table"
                                      >
                                        <option defaultValue>
                                          Select Table
                                        </option>
                                        {this.state.tables.map(
                                          (api, index, idx) => (
                                            <option key={index} value={api}>
                                              {api}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.taskstable}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Qualification Criteria 1
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={4}
                                        onChange={this.handledummyOneChange}
                                        className="form-control"
                                        name="dummyOne"
                                        value={this.state.dummyOne}
                                        required="required"
                                        placeholder="Enter Qualification Criteria 1"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyOne}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Qualification Criteria 2
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={4}
                                        onChange={this.handledummyTwoChange}
                                        className="form-control"
                                        name="dummyTwo"
                                        value={this.state.dummyTwo}
                                        required="required"
                                        placeholder="Enter Qualification Criteria 2"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyTwo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.UserstoriestablesubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Userstoriestable
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="tableName"
                                          onChange={
                                            this.handleprojectNameChange
                                          }
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Project Name{" "}
                                          </option>
                                          {this.state.itprojectstable.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.projectName}
                                              >
                                                {" "}
                                                {api.projectName}{" "}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          User Story{" "}
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={4}
                                          onChange={this.handleuserStoryChange}
                                          className="form-control"
                                          name="userStory"
                                          value={this.state.userStory}
                                          required="required"
                                          placeholder="Enter User Story "
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Tasks table
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          onChange={this.handletaskstableChange}
                                          className="form-control"
                                          name="taskstable"
                                          value={this.state.taskstable}
                                          required="required"
                                          placeholder="Enter Tasks table"
                                        >
                                          <option defaultValue>
                                            Select Table
                                          </option>
                                          {this.state.tables.map(
                                            (api, index, idx) => (
                                              <option key={index} value={api}>
                                                {api}
                                              </option>
                                            )
                                          )}
                                        </Form.Select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Qualification Criteria 1
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={4}
                                          onChange={this.handledummyOneChange}
                                          className="form-control"
                                          name="dummyOne"
                                          value={this.state.dummyOne}
                                          required="required"
                                          placeholder="Enter Qualification Criteria 1"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Qualification Criteria 2
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={4}
                                          onChange={this.handledummyTwoChange}
                                          className="form-control"
                                          name="dummyTwo"
                                          value={this.state.dummyTwo}
                                          required="required"
                                          placeholder="Enter Qualification Criteria 2"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.UserstoriestableupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }

                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
